import { inject, Injectable } from '@angular/core';
import { WidgetTabs } from '@com-delta-idp/mnx-sitewide-header-ui';
import { HeaderFooterMachCoreContentService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { BookingTabAdapterService } from '../../adapters/booking-tab/booking-tab-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class BookingTabFacadeService {
  adapter = inject(BookingTabAdapterService);
  bookingTabDetails$ = new BehaviorSubject<WidgetTabs | null>(null);
  bookingTab$ = new BehaviorSubject<string>('');
  content = inject(HeaderFooterMachCoreContentService);

  init(index = 0): void {
    this.content
      .getHeaderFooterMachCoreContent$()
      .pipe(take(1))
      .subscribe(({ header }) => {
        this.bookingTabDetails$.next(
          this.adapter.getContent(header.book.bellyBand, index)
        );
        this.bookingTab$.next(header.primaryNavigation[0].id);
      });
  }
}
